import { emission_factor_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateEmissionFactorTypeEnum = (enumValue: emission_factor_type_enum) => {
  switch (enumValue) {
    case emission_factor_type_enum.CRREM:
      return <Trans i18nKey="Enum_EmissionFactorTypeEnum-CRREM" />;
    case emission_factor_type_enum.CRREM_GEG:
      return <Trans i18nKey="Enum_EmissionFactorTypeEnum-CRREM_GEG" />;
    case emission_factor_type_enum.NATIONAL_ENERGY_LAW:
      return <Trans i18nKey="Enum_EmissionFactorTypeEnum-NATIONAL_ENERGY_LAW" />;
  }
};

export const translateEmissionFactorTypeEnum_dynamic = (enumValue: emission_factor_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case emission_factor_type_enum.CRREM:
      return t('Enum_EmissionFactorTypeEnum-CRREM');
    case emission_factor_type_enum.CRREM_GEG:
      return t('Enum_EmissionFactorTypeEnum-CRREM_GEG');
    case emission_factor_type_enum.NATIONAL_ENERGY_LAW:
      return t('Enum_EmissionFactorTypeEnum-NATIONAL_ENERGY_LAW');
  }
};
